import { render, staticRenderFns } from "./UndershirtsSizeModal.vue?vue&type=template&id=7b72636b&scoped=true&"
import script from "./UndershirtsSizeModal.vue?vue&type=script&lang=js&"
export * from "./UndershirtsSizeModal.vue?vue&type=script&lang=js&"
import style0 from "./UndershirtsSizeModal.vue?vue&type=style&index=0&id=7b72636b&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b72636b",
  null
  
)

export default component.exports